import React from "react";
import { IconCircle } from "../../assets/icons";
function TitleH6WithLine({ titleText }) {
  return (
    <div className="mt-5 mb-1 text-line">
      <span className="text-line-bg">
        <h6 className="fw-bold d-inline-block pe-3">{titleText}</h6>
        <IconCircle fillColor="#d9d9d9" />
        <IconCircle fillColor="#d9d9d9" />
        <IconCircle fillColor="#d9d9d9" />
      </span>
    </div>
  );
}
export default TitleH6WithLine;
